<!-- Copyright (c) 2022 VMware, Inc. All rights reserved. VMware Confidential -->

<div class="key" id="{{id}}">{{name}}</div>
<div class="value"
     [attr.aria-describedby]="id">
    <ng-content></ng-content>
</div>

